import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import HelpIcon from "@material-ui/icons/Help";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));

export default function ResetPassword(props) {
	const history = useHistory();
	const classes = useStyles();
	const [email, setEmail] = useState();
	const { enqueueSnackbar } = useSnackbar();

	const onChange = (e) => {
		setEmail({ ...email, [e.target.name]: e.target.value });
	};

	const onSubmit = (e) => {
		e.preventDefault();

		//Remove any keys with an empty str as the value
		for (const key of Object.keys(email)) {
			if (email[key] === "") {
				delete email[key];
			}
		}

		fetch(`${process.env.REACT_APP_API_URL}/auth/forgotpassword`, {
			method: "POST",
			credentials: "include",
			body: JSON.stringify(email),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					enqueueSnackbar(
						"If an account is associated with that email, please check your inbox for a reset password link.",
						{ variant: "success" }
					);
					history.push(`/${process.env.REACT_APP_ADMIN_URL}/login`);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						if (error === "There is no user with that email") {
							enqueueSnackbar(
								"If an account is associated with that email, please check your inbox for a reset password link.",
								{ variant: "success" }
							);
							history.push(`/${process.env.REACT_APP_ADMIN_URL}/login`);
						} else {
							enqueueSnackbar(`${error}`, { variant: "error" });
						}
					});
				}
			});
	};

	return (
		<Container component="main" maxWidth="xs">
			<div className={classes.paper}>
				<Avatar className={classes.avatar}>
					<HelpIcon />
				</Avatar>
				<Typography component="h1" variant="h5">
					Forgot Password
				</Typography>
				<form className={classes.form} onSubmit={onSubmit}>
					<TextField
						variant="outlined"
						margin="normal"
						required
						fullWidth
						name="email"
						label="E-mail"
						type="email"
						id="email"
						onChange={onChange}
						autoFocus
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						className={classes.submit}
					>
						Get Reset E-mail
					</Button>
				</form>
			</div>
		</Container>
	);
}
